// utils/date.js

export const MONTHS = [
  "ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
  "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"
];

export function dateParts(iso) {
  if (!iso) return { d: "", m: "" };
  const dt = new Date(iso);
  return {
    d: String(dt.getUTCDate()).padStart(2, "0"),
    m: MONTHS[dt.getUTCMonth()]
  };
}

export function isEventPast(isoDate) {
  if (!isoDate) return false;
  try {
    // Tomamos sólo la parte de la fecha (ej: "2026-02-22") para armar el límite exacto a 
    // las 23:59:59 en base al huso horario de Argentina (-03:00).
    const dateStr = isoDate.split('T')[0];
    const expirationDate = new Date(`${dateStr}T23:59:59-03:00`);
    return new Date() > expirationDate;
  } catch (e) {
    return false;
  }
}

export function isEventUpcoming(isoDate) {
  return !isEventPast(isoDate);
}
